import eventbus from 'tiny-emitter/instance';
import { TYPE, TABLE, SEATRADIUS, SEAT, DOUBLE_PI } from '@/constants';

import TableHelper from '../models/tables/index';
import Matrix from '../Matrix';

export default class DrawingTables {
  mouseListenerOptions = {
    passive: false,
    capture: false,
  };

  coords = Object.create(null);

  constructor(app, type) {
    this.app = app;
    this.svg = this.app.svg;
    this.canvas = this.app.canvas;
    this.type = type;
    this.setup();
    this.setupEventListeners();
    return this;
  }

  get x() {
    return this.rbox().cx;
  }

  get y() {
    return this.rbox().cy;
  }

  setup() {
    this.setCanvasCursor();
    this.drawTable();
    eventbus.emit('drawing:started');
  }

  setupEventListeners() {
    this.svg.on('mousemove', this.handleMouseMove, this);
    this.svg.on('click', this.handleMouseClick, this);
  }

  setCanvasCursor() {
    // this.svg.attr({ cursor: 'none' });
  }

  handleMouseClick(e) {
    if (e.button !== 0) return;
    const sid = this.app.currentSection && this.app.currentSection.uuid;
    const { x, y } = this.app.getTransformedCoords(e);
    const unit = TableHelper.addTable(this.type, [x, y], { sid });
    eventbus.emit('seatmap:add:unit', unit, false);

    // reassign section to caregory to update seat categories
    if (this.app.currentSection) {
      eventbus.emit('section:category:assign', this.app.currentSection, this.app.currentSection.categoryId);
    }
  }

  handleMouseMove(e) {
    const { x, y } = this.app.getTransformedCoords(e);

    const { cx, cy } = this.view.rbox(this.svg);
    const scale = this.app.seatmap.scale;

    const m = new Matrix({
      scale,
      ox: cx,
      oy: cy,
      rx: x,
      ry: y,
    });

    this.view.transform(m);
  }

  drawTable() {
    this.view = this.canvas.group().addClass('drawing-table');
    switch (this.type) {
      case TYPE.TABLE_RECTANGULAR:
        this.drawRectangularTable();
        break;
      case TYPE.TABLE_ROUNDED:
      default:
        this.drawRoundedTable();
        break;
    }
  }

  drawRectangularTable() {
    this.shape = this.view.rect(TABLE.RECTANGULAR.WIDTH, TABLE.RECTANGULAR.HEIGHT).addClass('table-shape').center(0, 0);

    const halfSeats = TABLE.RECTANGULAR.SEATSCOUNT / 2;
    const halfHeight = TABLE.RECTANGULAR.HEIGHT / 2;
    const coef = TABLE.RECTANGULAR.WIDTH / halfSeats;
    const tdy = this.y - SEATRADIUS - halfHeight;
    const bdy = this.y + SEATRADIUS + halfHeight;
    this.drawSeatsForRectangularTable(coef, tdy);
    this.drawSeatsForRectangularTable(coef, bdy);
    this.view.scale(this.app.seatmap.scale);
  }

  drawSeatsForRectangularTable(coef, cy) {
    const halfCoef = coef / 2;
    const halfSeats = TABLE.RECTANGULAR.SEATSCOUNT / 2;
    const halfWidth = TABLE.RECTANGULAR.WIDTH / 2;
    for (let i = 0; i < halfSeats; i++) {
      const cx = this.x - halfWidth + halfCoef + coef * i;
      const seat = this.view.circle(SEAT.INNER_RADIUS).addClass('seat-shape');
      seat.attr({ cx, cy });
    }
  }

  drawRoundedTable() {
    this.shape = this.view
      .circle(TABLE.ROUNDED.RADIUS * 2)
      .addClass('table-shape')
      .center(0, 0);
    const dr = TABLE.ROUNDED.RADIUS + SEATRADIUS;
    const angle = DOUBLE_PI / TABLE.ROUNDED.SEATSCOUNT;
    for (let i = 0; i < TABLE.ROUNDED.SEATSCOUNT; i++) {
      const da = angle * i;
      const cx = this.x + Math.sin(da) * dr;
      const cy = this.y + Math.cos(da) * dr;
      const seat = this.view.circle(SEAT.INNER_RADIUS).addClass('seat-shape');
      seat.attr({ cx, cy });
    }
    this.view.scale(this.app.seatmap.scale);
  }

  rbox(parent = this.svg) {
    return this.shape.rbox(parent);
  }

  resetCanvasCursor() {
    this.svg.attr({ cursor: 'default' });
  }

  destroyDrawingTable() {
    this.view.remove();
  }

  destroyEventListeners() {
    this.svg.off('mousemove', this.handleMouseMove);
    this.svg.off('click', this.handleMouseClick);
  }

  destroy() {
    this.resetCanvasCursor();
    this.destroyEventListeners();
    this.destroyDrawingTable();
  }
}
